import React from 'react'
import { JustificationLabel } from 'packages/eid-ui/JustificationSelector'
import { useJustificationOptions } from 'hooks'

const CellJustification = ({ data }) => {
    const { data: justificationOptions = [], isLoading } =
        useJustificationOptions()

    return (
        <JustificationLabel
            value={data.justificationComment}
            options={justificationOptions}
            isLoading={isLoading}
        />
    )
}

export default CellJustification
